import Vue from 'vue'

const savedQueriesTimesheet = {
  state: {
    savedQueriesTimesheet: [],
    selectedSavedQueriesTimesheet: {},
  },

  getters: {
    savedQueriesTimesheet(state) {
      return state.savedQueriesTimesheet
    },
    selectedSavedQueriesTimesheet(state) {
      return state.selectedSavedQueriesTimesheet
    },
  },

  mutations: {
    savedQueriesTimesheet(state, payload) {
      state.savedQueriesTimesheet = payload
    },
    selectedSavedQueriesTimesheet(state, payload) {
      state.selectedSavedQueriesTimesheet = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedSavedQueriesTimesheet(context, payload) {
      context.commit('selectedSavedQueriesTimesheet', payload)
    },
    loadSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SavedQueriesTimesheet'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('savedQueriesTimesheet', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SavedQueriesTimesheet/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedSavedQueriesTimesheet', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesTimesheet/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesTimesheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesTimesheet`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesTimesheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateSavedQueriesTimesheet', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createSavedQueriesTimesheet', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteSavedQueriesTimesheet(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesTimesheet/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesTimesheet')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default savedQueriesTimesheet
